import moment from 'moment';

import schema from './schema';

import { cloneObject, addMaskCellphone, addMaskCpf, addMaskPis, addMaskSus } from '../../../../utils';

const DATE_FORMAT = 'MM/DD/YYYY h:mm:ss';

function translateToSchema(response) {
    const dataBeneficiario = cloneObject(schema);

    const residencial = response.enderecos?.length > 0 ? response.enderecos.find(end => end.eResidencial === true) : {};

    dataBeneficiario.address.value = residencial?.logradouro;
    dataBeneficiario.addressNumber.value = residencial?.numero;
    dataBeneficiario.admissionDate.value =
        response.dataAdmissao && moment(response.dataAdmissao, DATE_FORMAT).toISOString();
    dataBeneficiario.birth.value = response.dtNascimento && moment(response.dtNascimento, DATE_FORMAT).toISOString();
    dataBeneficiario.capacity.value = response.lotacao?.codigo;
    dataBeneficiario.capacity.lookup = response.lotacao?.nome;
    dataBeneficiario.cellphone.value = addMaskCellphone(`${response.celular.ddd}${response.celular.numero}`);
    dataBeneficiario.cellphone.unmaskedValue = `(${response.celular.ddd}) ${response.celular.numero}`;
    dataBeneficiario.cep.value = residencial?.cep;
    dataBeneficiario.cep.unmaskedValue = residencial?.cep ? residencial?.cep.replace(/\W/g, '') : '';
    dataBeneficiario.city.value = residencial?.cidade?.codigo;
    dataBeneficiario.city.lookup = residencial?.cidade?.nome;
    dataBeneficiario.civilState.value = response.estadoCivil.codigo;
    dataBeneficiario.civilState.lookup = response.estadoCivil.nome;
    dataBeneficiario.complement.value = residencial?.complemento;
    dataBeneficiario.costCenter.value = response.centroCusto?.codigo;
    dataBeneficiario.costCenter.lookup = response.centroCusto?.nome;
    dataBeneficiario.startDate.value = response.dtInicioContribuicao;
    dataBeneficiario.cpf.value = addMaskCpf(response.cpf);
    dataBeneficiario.cpf.unmaskedValue = response.cpf?.replace(/\W/g, '');
    dataBeneficiario.dn.value = response.numDeclaracaoNascidoVivo;
    dataBeneficiario.email.value = response.email;
    dataBeneficiario.enrollmentSequence.value = response.numSequencialMatriculaEmpresa;
    dataBeneficiario.fullName.value = response.nomeCompleto;
    dataBeneficiario.functionalEnrollment.value = response.numMatriculaEmpresa;
    dataBeneficiario.functionalStatus.value = response.situacaoEmpresa.codigo;
    dataBeneficiario.functionalStatus.lookup = response.situacaoEmpresa.nome;
    dataBeneficiario.gender.value = response.sexo;
    dataBeneficiario.gender.lookup = response.sexo === 'M' ? 'Masculino' : 'Feminino';
    dataBeneficiario.hood.value = residencial?.bairro;
    dataBeneficiario.motherName.value = response.nomeMae;
    dataBeneficiario.nationality.value = response.nacionalidade;
    dataBeneficiario.nationality.lookup = response.nacionalidade === 'B' ? 'Brasilei' : 'Estrangeira';
    dataBeneficiario.pis.value = addMaskPis(response.numPis);
    dataBeneficiario.pis.unmaskedValue = response.numPis;
    dataBeneficiario.socialName.value = response.nomeSocial;
    dataBeneficiario.startCapacity.value =
        response.dataInicioLotacao && moment(response.dataInicioLotacao, DATE_FORMAT).toISOString();
    dataBeneficiario.sus.value = addMaskSus(response.numSus);
    dataBeneficiario.uf.lookup = residencial?.estado?.nome;
    dataBeneficiario.uf.value = residencial?.estado?.codigo;
    dataBeneficiario.occupation.value = response?.funcao?.codigo;
    dataBeneficiario.occupation.lookup = response?.funcao?.nome;

    dataBeneficiario.stateService.value = residencial?.ufAtendimento;
    dataBeneficiario.stateService.lookup = residencial?.ufAtendimento; // TODO: must be the nam.
    dataBeneficiario.countyService.value = residencial?.codigoMunicipioAtendimento;
    dataBeneficiario.countyService.lookup = residencial?.nomeMunicipioAtendimento;
    dataBeneficiario.congenerName.value = '';

    return dataBeneficiario;
}

export default translateToSchema;
